import { DOCUMENT, isPlatformServer } from '@angular/common';
import { APP_INITIALIZER, EnvironmentProviders, Inject, PLATFORM_ID, makeEnvironmentProviders } from '@angular/core';
import { SvgIconAppComputedStylesService } from '@bcfds-design-system/svg-icon/svg-icon-app-computed-styles.service';
import { provideSvgIcon } from '@bcfds-design-system2/v1/components/svg-icon/svg-icon.providers';
import { SVG_ICON_HOST, SVG_ICON_IDENTIFIER } from './token';
import { SvgIconIdentifier } from './types';

const defaultSvgIconHost: string = 'https://image-assets-server-dot-cms-headless-gae.ew.r.appspot.com';

export function provideSvgIcons(svgIconsIdentifier: SvgIconIdentifier, svgIconHost?: string): EnvironmentProviders {
  const host: string = svgIconHost ?? defaultSvgIconHost;
  return makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      useFactory:
        (svgIconAppComputedStyles: SvgIconAppComputedStylesService, document: Document, platformId: string) =>
        async () => {
          if (isPlatformServer(platformId)) {
            return;
          }
          svgIconAppComputedStyles.setComputedStyles(getComputedStyle(document.body));
        },
      deps: [SvgIconAppComputedStylesService, [new Inject(DOCUMENT)], [new Inject(PLATFORM_ID)]],
      multi: true
    },
    {
      provide: SVG_ICON_IDENTIFIER,
      useValue: svgIconsIdentifier
    },
    {
      provide: SVG_ICON_HOST,
      useValue: host
    },
    // gen-2 DS components (e.g. toast) read icons through the gen-2 token; gen-2 expects a trailing slash.
    ...provideSvgIcon({ brand: svgIconsIdentifier, hostUrl: host.endsWith('/') ? host : `${host}/` })
  ]);
}
